import React, {type ReactNode} from "react";
import styles from "./ErrorText.module.scss"
import { combineClasses } from "@/lib/utils";

interface  ErrorTextProps{
  children: ReactNode;
}
const ErrorText: React.FC<ErrorTextProps>= ({ children }) => {
  return <p className={combineClasses(styles.validation_text, Boolean(children) && styles.show)}>{children}</p>;
};

export default ErrorText;
